import React, { useEffect, useState } from "react";
import Modal from "../../Elements/Modal/Modal";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import { fetchCountriesByRegion } from "../../../services/PackagesService";
import "./RegionCountriesModal.css";

const RegionCountriesModal = ({ isOpen, onClose, regionId, regionName }) => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen || !regionId) return;

    const load = async () => {
      try {
        setLoading(true);
        setError("");
        const data = await fetchCountriesByRegion({
          regionId,
          currency: "EUR",
        });
        setCountries(data.items || []);
      } catch (e) {
        setError("Failed to load countries for this region.");
        setCountries([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [isOpen, regionId]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Countries in ${regionName}`}
      actions={<SecondButton onClick={onClose}>Close</SecondButton>}
    >
      <div className="region-countries-modal-body">
        {loading && <p className="text-muted">Loading countries...</p>}
        {error && <p className="text-muted">{error}</p>}

        {!loading && !error && countries.length === 0 && (
          <p className="text-muted">No countries found for this region.</p>
        )}

        {!loading && !error && countries.length > 0 && (
          <ul className="region-countries-list">
            {countries.map((c) => {
              const code = c.id ? String(c.id).toLowerCase() : "";
              const flagSrc = code ? `/icons/flags/${code}.png` : null;

              return (
                <li key={c.id} className="region-country-item">
                  <div className="region-country-left">
                    {flagSrc && <img src={flagSrc} alt={c.name} className="region-country-flag" />}
                    <span className="region-country-name">{c.name}</span>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </Modal>
  );
};

export default RegionCountriesModal;
